/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    export class MixingDetailsEditor extends Common.GridEditorBase<MixingDetailsRow> {
        Editable() {
            this.slickGrid.getOptions().editable;
        }
       protected getColumnsKey() { return "Inventory.MixingDetails"; }
        protected getDialogType() { return MixingDetailsDialog; }
        protected getLocalTextPrefix() { return MixingDetailsRow.localTextPrefix; }
        protected form: MixingDetailsForm;

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number; 
        // #endregion 

        constructor(container: JQuery) {
            super(container);
        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });


            return columns;
        }

        // #endregion

       
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => { 
                        var id = this.id(item); 
                        this.view.deleteItem(id);
                    });
                    this.view.refresh();
                }

                if (target.hasClass('gen-sku')) {
                    //set items on dialog open 
                    let recordId = item[this.getIdProperty()];//get id
                    this.editItem(recordId);//set as edit
                }
                this.view.refresh();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


       

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockStoneSelectGrid;

            buttons.pop();

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Lot No",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    if (this.view.getItems().length == 1) {
                        Q.alert('Only one item can be selected');
                        return;
                    }

                    var filters: _Ext.SelectGridFilters = {

                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        if (selectedItems2.length > 1) {
                            Q.alert('Only one item can be selected');
                            return;
                        } else {
                            var orddetails = []; 
                            // #region Items to Grid
                            selectedItems2.forEach(function (value: Stock.StockItemRow) {
                                var PrdId = value.ProductId;
                                //var bomdetails = []; 
                                 

                                // #endregion
                                var purchase: MixingDetailsRow = {
                                    ProductId: PrdId,
                                    AttributeId: value.AttributeId,
                                    Line_No: value.Line_No,
                                    SKU: value.SKU,
                                    LotNo: value.LotNo,
                                    DepartmentId: value.DepartmentId,
                                    ProductCode: value.ProductCode,
                                    ProductName: value.ProductName,
                                    ItemTypeId: value.ItemTypeId,
                                    CategoryId: value.CategoryId,
                                    ProductTypeId: value.ProductTypeId,
                                    SubCategoryId: value.SubCategoryId,

                                    UnitRate: value.Rate,
                                    //  UnitLabour: LaborRate,
                                    Pieces: value.Pieces,
                                    Weight: value.Weight,
                                    NetWeight: value.NetWeight,
                                    CalcOnId: value.CalcOnId,
                                    SieveId: value.SieveId,
                                    QualityId: value.QualityId,
                                    ShapeId: value.ShapeId,
                                    StoneColorId: value.StoneColorId,
                                    StoneSizeId: value.StoneSizeId,
                                    //BOMDetails: bomdetails,
                                    //  LaborDetails: labordetail,
                                    CompanyId: value.CompanyId,
                                    TransId: value.TransId,
                                    VoucherTypeId: 74,
                                    RefVoucherId: value.VoucherTypeId,
                                    HasBom: value.HasBom,
                                    Hsn: value.HSN,
                                    RefTransId: value.TransId,
                                    RefTransItemId: value.TransItemId,

                                };
                                orddetails.push(purchase);

                            });


                            for (let orderDetail of orddetails) {
                                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                                this.view.addItem(orderDetail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        }



        // #endregion
         
    }
}